import {createBrowserRouter, Navigate} from 'react-router-dom';

import {
    Auth,
    ExpenseList,
    ExpenseDetails,
    Login,
    RecurringExpenseList,
    RecurringExpenseDetails,
    Analytics,
} from './pods';

export const router = createBrowserRouter([
    {path: '/auth', element: <Login/>},
    {
        path:     '/auth',
        element:  <Auth/>,
        children: [
            {path: 'expenses', element: <ExpenseList/>},
            {path: 'expenses/:id', element: <ExpenseDetails/>},
            {path: 'recurring-expenses', element: <RecurringExpenseList/>},
            {path: 'recurring-expenses/:id', element: <RecurringExpenseDetails/>},
            {path: 'analytics', element: <Analytics/>},
        ],
    },
    {path: '*', element: <Navigate to={'/auth'}/>},
]) as ReturnType<typeof createBrowserRouter>;
